import { render, staticRenderFns } from "./CollectionVideos.vue?vue&type=template&id=f410f7a0&scoped=true"
import script from "./CollectionVideos.vue?vue&type=script&lang=js"
export * from "./CollectionVideos.vue?vue&type=script&lang=js"
import style0 from "./CollectionVideos.vue?vue&type=style&index=0&id=f410f7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f410f7a0",
  null
  
)

export default component.exports